import { BASE_BUTTON_HEIGHTS } from '../BaseButton/BaseButton.constants';
import { BaseButtonProps } from '../BaseButton/BaseButton.types';
import { IconButtonSizeType } from './IconButton.types';

export const ICON_BUTTON_SIZES: {
    [key in IconButtonSizeType]: {
        height: BaseButtonProps['height'];
        width: BaseButtonProps['width'];
    };
} = {
    sm: {
        height: BASE_BUTTON_HEIGHTS.sm,
        width: BASE_BUTTON_HEIGHTS.sm,
    },
    md: {
        height: BASE_BUTTON_HEIGHTS.md,
        width: BASE_BUTTON_HEIGHTS.md,
    },
    lg: {
        height: BASE_BUTTON_HEIGHTS.lg,
        width: BASE_BUTTON_HEIGHTS.lg,
    },
};
